import { render, staticRenderFns } from "./notice-edit.vue?vue&type=template&id=8d304faa&scoped=true&"
import script from "./notice-edit.vue?vue&type=script&lang=js&"
export * from "./notice-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d304faa",
  null
  
)

export default component.exports